// applyOrder puts a list into the order a drag left it in, leaving anything the
// order doesn't name at the end in the order it was already in. It stands in for
// the server's answer until that arrives.
export function applyOrder<T extends { id: number }>(items: T[], order: number[] | null) {
    if (!order) return items;

    const index = new Map(order.map((id, at) => [id, at]));
    return items.slice().sort((a, b) =>
        (index.get(a.id) ?? order.length) - (index.get(b.id) ?? order.length));
}
